'use strict';
'use es6';

// SEND

Object.defineProperty(exports, "__esModule", {
  value: true
});
var IFRAME_RESIZE = exports.IFRAME_RESIZE = 'iframe-resize';

var OPEN_CHANGE = exports.OPEN_CHANGE = 'open-change';

var CLOSED_WELCOME_MESSAGE = exports.CLOSED_WELCOME_MESSAGE = 'closed-welcome-message';

var REQUEST_WIDGET = exports.REQUEST_WIDGET = 'request-widget';

var STORE_MESSAGES_COOKIE = exports.STORE_MESSAGES_COOKIE = 'store-messages-cookie';

var SHOW_PAGE_TITLE_NOTIFICATION = exports.SHOW_PAGE_TITLE_NOTIFICATION = 'show-page-title-notification';

var CLEAR_PAGE_TITLE_NOTIFICATION = exports.CLEAR_PAGE_TITLE_NOTIFICATION = 'clear-page-title-notification';

// RECEIVE

var WIDGET_DATA = exports.WIDGET_DATA = 'widget-data';

var REFRESH_WIDGET_DATA = exports.REFRESH_WIDGET_DATA = 'refresh-widget-data';

var REQUEST_OPEN = exports.REQUEST_OPEN = 'request-open';

var REQUEST_CLOSE = exports.REQUEST_CLOSE = 'request-close';

var BROWSER_WINDOW_RESIZE = exports.BROWSER_WINDOW_RESIZE = 'browser-window-resize';


//////////////////
// WEBPACK FOOTER
// ./js/constants/PostMessageTypes.js
// module id = 101
// module chunks = 2 3